import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { buildBlocks } from "../../../services/builder";

export const AcfTimedContainerBlock = (props) => {
  const blocks = buildBlocks(
    props.innerBlocks,
    props.attributes,
    props.pageContext
  );

  const { startDate, endDate } = props.block.blockTimedContent;

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  let start =
    startDate !== null ? new Date(startDate.replace(/-/g, "/")) : null;
  let end = endDate !== null ? new Date(endDate.replace(/-/g, "/")) : null;

  if (
    (start === null && endDate === null) ||
    (startDate !== null && endDate === null && currentTime > start) ||
    (endDate !== null && startDate === null && currentTime < end) ||
    (startDate !== null &&
      endDate !== null &&
      currentTime > start &&
      currentTime < end)
  ) {
    return (
      <>
        {blocks.map((block) => {
          return block;
        })}
      </>
    );
  } else {
    return null;
  }
};

AcfTimedContainerBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

export const AcfTimedContainerBlockFragment = graphql`
  fragment AcfTimedContainerBlock on WpBlock {
    ... on WpAcfTimedContainerBlock {
      name
      attributes {
        className
      }
      blockTimedContent {
        startDate
        endDate
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const AcfTimedContainerBlockPreview = `
  ... on AcfTimedContainerBlock {
      name
      attributes {
          className
      }
      blockTimedContent {
        startDate
        endDate
      }
  }
`;
